module.exports = __webpack_public_path__ + "img/Cherry in Hoge room.6286af05.jpg";